export const formatPercent = value => (
  typeof value === 'number' ? (value * 100).toFixed(0) : ''
);